const isProd = process.env.REACT_APP_ENV === 'production';
const isDev = process.env.REACT_APP_ENV === 'development';
const isLocal = process.env.REACT_APP_ENV === 'local';

// Original API URLs (for non-loyalty endpoints)
const DEV_URL = 'https://api-dev.nextorder.co/';
const PROD_URL = 'https://api.nextorder.co/';

// Firebase Functions URLs for loyalty endpoints
const LOYALTY_PROD_URL =
  'https://us-central1-next-order-prodenv.cloudfunctions.net/';
const LOYALTY_DEV_URL =
  'https://us-central1-next-order-devenv.cloudfunctions.net/';
const LOYALTY_LOCAL_URL =
  'http://127.0.0.1:5003/next-order-devenv/us-central1/';

// Main API URL for non-loyalty endpoints (environment-based)
export const API_URL = isProd ? PROD_URL : DEV_URL;

// Loyalty API URL - using local for testing the migrated endpoints

// For production deployment, use this instead:
export const LOYALTY_API_URL = isProd
  ? LOYALTY_PROD_URL
  : isDev
  ? LOYALTY_DEV_URL
  : isLocal
  ? LOYALTY_LOCAL_URL
  : LOYALTY_DEV_URL;
